
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(29|73|90)|271)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
